#import "../fragments/materialized-message-body-fragment.graphql"

query GetMessageBody($emailTemplateId: ID!, $entityId: ID!) {
    materializedEmailTemplate(emailTemplateId: $emailTemplateId, entityId: $entityId) {
        ...MaterializedMessageBody
    }
}
